import React from 'react';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Select, DatePicker } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './css/PastWeatherControls.css';
import { getYears } from '../../utils/getYears';
import { trackEvent } from '../../actions/analyticsActions';

const ALL_OTHER_CROPS_START_DATE = '1/1';
const ALL_OTHER_CROPS_END_DATE = '12/31';

function onDateSelected(e, name, yearAverage, funcs) {
  const { updatePastWeatherInput, getPastWeather, getHistoricalWeather } =
    funcs;
  const numbers = yearAverage.match(/\d+/);
  const numYears = numbers && numbers[0];
  if (name === 'harvestYear') {
    updatePastWeatherInput(
      'endDate',
      moment(`${ALL_OTHER_CROPS_END_DATE  }/${  e.target.value}`).format()
    );
    updatePastWeatherInput(
      'startDate',
      moment(`${ALL_OTHER_CROPS_START_DATE  }/${  e.target.value}`).format()
    );
    updatePastWeatherInput(name, e.target.value);
  } else {
    updatePastWeatherInput(name, e.format());
  }
  getPastWeather();

  if (numYears) {
    getHistoricalWeather();
  }
}

const years = getYears();

export function PastWeatherControls({
  endDate,
  getHistoricalWeather,
  getPastWeather,
  harvestYear,
  startDate,
  trackEventAnalytics,
  updatePastWeatherInput,
  updateValue,
  yearAverage,
}) {
  const funcs = {
    updatePastWeatherInput,
    getPastWeather,
    getHistoricalWeather,
  };
  const onStartDateSelected = (e) => {
    onDateSelected(e, 'startDate', yearAverage, funcs);
    trackEventAnalytics('past_weather', 'updated', {
      updated_option: 'date_range',
      updated_value: e.format(),
      updated_value_2: endDate ? moment(endDate) : moment(),
    });
  };
  const onEndDateSelected = (e) => {
    onDateSelected(e, 'endDate', yearAverage, funcs);
    trackEventAnalytics('past_weather', 'updated', {
      updated_option: 'date_range',
      updated_value: startDate
        ? moment(startDate)
        : moment().subtract(365, 'd'),
      updated_value_2: e.format(),
    });
  };
  const onHarvestYear = (e) => {
    onDateSelected(e, 'harvestYear', yearAverage, funcs);
    trackEventAnalytics('past_weather', 'updated', {
      updated_option: 'harvest_year',
      updated_value: e.target.value,
    });
  };

  const yearsOptions = years.map((year) => <option key={year}>{year}</option>);
  return (
    <div>
      <div className={styles.title}>{getMessage('past.title')}</div>
      <div className={styles.controls}>
        <div className={styles.dateControls}>
          <div className={styles.dateRange}>
            <span className={styles.label}>
              {getMessage('past.controls.dateRangeLbl')}
            </span>
            <DatePicker
              className={styles.datePicker}
              label={getMessage('past.controls.startDate')}
              maxDate={moment(endDate)}
              minDate={null}
              moment={moment}
              onChangeDate={onStartDateSelected}
              selected={moment(startDate)}
            />
            <DatePicker
              className={styles.datePicker}
              label={getMessage('past.controls.endDate')}
              maxDate={moment()}
              minDate={moment(startDate)}
              moment={moment}
              onChangeDate={onEndDateSelected}
              selected={moment(endDate)}
            />
          </div>
        </div>
        <div className={styles.yearContainer}>
          <span className={styles.label}>
            {getMessage('past.controls.harvestYearLbl')}
          </span>
          <Select
            label="harvest"
            name="harvestYear"
            onChange={onHarvestYear}
            testId="harvest-year-selector"
            value={harvestYear}
          >
            {yearsOptions}
          </Select>
          <span className={styles.label}>
            {getMessage('past.controls.compareLbl')}
          </span>
          <Select
            name="yearAverage"
            onChange={updateValue}
            testId="year-average-select"
            value={yearAverage}
          >
            <option>{getMessage('past.controls.compareOpt.none')}</option>
            <option>{getMessage('past.controls.compareOpt.year5')}</option>
            <option>{getMessage('past.controls.compareOpt.year15')}</option>
            <option>{getMessage('past.controls.compareOpt.year30')}</option>
          </Select>
        </div>
      </div>
    </div>
  );
}

PastWeatherControls.propTypes = {
  endDate: string.isRequired,
  getHistoricalWeather: func.isRequired,
  getPastWeather: func.isRequired,
  harvestYear: string,
  startDate: string.isRequired,
  trackEventAnalytics: func.isRequired,
  updatePastWeatherInput: func.isRequired,
  updateValue: func.isRequired,
  yearAverage: string,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      trackEventAnalytics: trackEvent,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(PastWeatherControls);
